module.exports = new Promise((resolve) => {
                    var remoteUrl = '__REACT_APP_AMA_URL__/adminRemoteEntry.js?v=1791386973693';
                    var script = document.createElement('script');
                    script.src = remoteUrl;
                    script.onload = function() {
                        var proxy = {
                            get: function(request) { return window.AdminConsole.get(request); },
                            init: function(arg) {
                                try { return window.AdminConsole.init(arg); }
                                catch(e) { console.log('AdminConsole container already initialized'); }
                            }
                        };
                        resolve(proxy);
                    };
                    script.onerror = function() {
                        console.warn('AdminConsole remote entry failed to load from: ' + remoteUrl);
                        resolve({
                            get: function() { return Promise.resolve(function() { throw new Error('AdminConsole remote is unavailable'); }); },
                            init: function() {}
                        });
                    };
                    document.head.appendChild(script);
                });